export { default } from './StudentImage';
